import 'slick-carousel';

// .js-home-mv-slider
$(function() {
	$('.js-home-mv-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 2000,
		autoplay: true,
		fade: true,
		speed: 3000,
		dots: true,
		arrows: false,
	});
});
